import React from "react"

// Links to the CSV export with the current filters as query params. Only
// rendered when the partner is owner/admin (canExport from the policy). A plain
// anchor download keeps it simple — no fetch/blob dance needed.
export function ExportButton({ exportPath, filters, copy }) {
  const params = new URLSearchParams()
  Object.entries(filters).forEach(([k, v]) => {
    if (v) params.set(k, v)
  })
  const sep = exportPath.includes("?") ? "&" : "?"
  const href = `${exportPath}${params.toString() ? `${sep}${params}` : ""}`

  return (
    <a
      href={href}
      className="inline-flex items-center rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
    >
      {copy.export.label}
    </a>
  )
}
